var styles = {
  "Droppable": "Online-Store-UI-DroppableRegion__Droppable_1ickc",
  "DroppableInterior": "Online-Store-UI-DroppableRegion__DroppableInterior_9s3qg",
  "DroppableBottom": "Online-Store-UI-DroppableRegion__DroppableBottom_1lurq",
  "DroppableMid": "Online-Store-UI-DroppableRegion__DroppableMid_11xpm",
  "DroppableTop": "Online-Store-UI-DroppableRegion__DroppableTop_1whaj"
};

export { styles as default };
